import { checkCreditSourceBookRowCommonParams } from './checkCreditSourceBookRowCommonParams.js';
export const getCreditCalculatorLimitParams = ({ limitRows, userInputParams, paramsViewSettings, }) => limitRows?.find((row) => checkCreditSourceBookRowCommonParams({
    row,
    userInputParams,
    paramsViewSettings,
}));
//# sourceMappingURL=getCreditCalculatorLimitParams.js.map